import { TSobReportSalesType } from 'legacy/lut/components/widgets/public/partner360/configs/reports'

interface IGetActualsCYQNetNdpFieldParams {
  field: 'Actuals' | 'Plans' | 'ExpExit'
  quarter: number
  netNdp: TSobReportSalesType
}

export const getActualsCYQNetNdpField = ({
  field,
  quarter,
  netNdp,
}: IGetActualsCYQNetNdpFieldParams) => {
  return `${field}CYQ${quarter}${netNdp}`
}
